<template>
	<div class="pagelist">
		<el-pagination background small @size-change="handleSizeChange" @current-change="handleCurrentChange" :hide-on-single-page="false" :current-page="pagination.page" :page-sizes="[10,15, 20, 30,50]" :page-size="pagination.size" layout="total,sizes,prev,pager,jumper,next" :total="paginationTotal">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		props: {
			pagination: {
				type: Object,
			},
			paginationTotal: {
				type: Number
			}
		},
		methods:{
			// 条数变化
			handleSizeChange(e) {
				this.$emit('handleSizeChange', e);
			},
			// 页码变化
			handleCurrentChange(e) {
				this.$emit('handleCurrentChange', e);
			},

		}
	}
</script>

<style lang="scss" scoped>
	.pagelist{
		padding-top: 16px;
		text-align: right;
		overflow: hidden;
	}
	.el-pagination{
		display: block;
	}
	::v-deep(.el-pagination.is-background .btn-prev){display: inline-block; vertical-align: top;}
	::v-deep(.el-pagination.is-background .btn-next){display: inline-block;vertical-align: top;}
	::v-deep(.el-pager){display: inline-block;vertical-align: top; text-align: center;}
	::v-deep(.el-pager li){display: inline-block;}
	::v-deep(.el-pagination.is-background .el-pager li){margin: 0 2px;}
	::v-deep(.el-pagination__total){float: left; line-height: 25px;}
	::v-deep(.el-pagination__sizes){float: left; margin-left: 5px;}
	::v-deep(.el-pagination__jump){float: left; margin-left: 5px;}
</style>

